module.exports = "https://static.wmbcdn.com/uniweb/images/20d0142031d8babc0419234ef254fcf7.svg";